import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UZURV_API_CONFIGURATION, UzurvApiConfiguration } from '@uzurv/rideWss/configurations/uzurv-api.configuration';

@Injectable()
export class HttpDebugInterceptor implements HttpInterceptor {
  constructor(@Inject(UZURV_API_CONFIGURATION) protected uzurvApiConfiguration: UzurvApiConfiguration) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.uzurvApiConfiguration.httpDebugMode) {
      if (this.uzurvApiConfiguration.httpDebugMode) {
        console.dir('== HTTP Request == ' + JSON.stringify(request, undefined, 2));
      }
    }

    return next
      .handle(request)
      .pipe(
        map(event => {
          if (this.uzurvApiConfiguration.httpDebugMode) {
            if (event instanceof HttpResponse) {
              console.dir('== HTTP Response == ' + JSON.stringify(event, undefined, 2));
            }
          }
          return event;
        })
      )
      .pipe(
        catchError(response => {
          if (this.uzurvApiConfiguration.httpDebugMode) {
            console.dir('== HTTP Error == ' + JSON.stringify(response, undefined, 2));
          }
          return throwError(response);
        })
      );
  }
}
